import http from '../axios';

export function index(id) {
  return http.get(`/vessel_owners?id=${id}`);
}